<template>
    <v-footer app bottom fixed class="socmed-container">
       <div class="copyright">
                       <span style="width:50%;font-size:.575rem;">©2022 Emerson Electric Co. All rights reserved.</span>
                       <div class="socmed">
                       <a
                           href="https://www.facebook.com/EmersonCorporate/"
                           aria-label=""
                           target="_blank"
                           class="socmed-content"
                       >
                           <img
                               src="../assets/images/footer-social-icon-facebook.png"
                               alt="Footer Social Icon - Facebook"
                               class="socmed-image"
                           />
                       </a>
                       <a
                           href="https://www.linkedin.com/company/emerson"
                           aria-label=""
                           target="_blank"
                           class="socmed-content"
                       >
                           <img
                               src="../assets/images/footer-social-icon-linkedin.png"
                               alt="Footer Social Icon - Linkedin"
                               class="socmed-image"
                           />
                       </a>
                       <a
                           href="https://twitter.com/Emerson_News"
                           aria-label=""
                           target="_blank"
                           class="socmed-content"
                           
                       >
                           <img
                                   src="../assets/images/footer-social-icon-twitter.png"
                                   alt="Footer Social Icon - Twitter"
                                   class="socmed-image"
                               />
                       </a>
                       <a
                           href="https://www.youtube.com/user/emerson"
                           aria-label=""
                           target="_blank"
                           class="socmed-content"
                       >
                           <img
                               src="../assets/images/footer-social-icon-youtube.png"
                               alt="Footer Social Icon - YouTube"
                               class="socmed-image"
                           />
                       </a>
                   </div>
                   </div>
                   <div class="privacy-container">
                       <a
                           target="_blank"
                           href="https://www.emerson.com/en-us/privacy-notice"
                           class="privacy-content"
                       >
                           Privacy Notice
                       </a>
                       <a
                           target="_blank"
                           href="https://www.emerson.com/en-us/cookie-notice"
                           class="privacy-content"
                       >
                           Cookies
                       </a>
                       <a
                           target="_blank"
                           href="https://www.emerson.com/en-us/terms-of-use"
                           class="privacy-content"
                       >
                           Terms of Use
                       </a>
                       <a
                           target="_blank"
                           href="https://www.emerson.com/en-us/data-protection"
                           class="privacy-content"
                       >
                           Data Protection
                       </a>
                       <a
                           target="_blank"
                           href="https://www.emerson.com/en-us/imprint"
                           class="privacy-content"
                       >
                           Imprint
                       </a>
                       <a
                           target="_blank"
                           href="https://www.emerson.com/en-us/accessibility"
                           class="privacy-content"
                       >
                           Accessibility
                       </a>
                       <router-link class="privacy-content" to="/disclaimer">Disclaimer</router-link>
                   </div>
       </v-footer>
</template>

<script>
export default {
 name:"MobileEmersonFooter",
 methods:{
   showDisclaimer(){
       this.$store.state.showDisclaimer = true
   }
 }
}

</script>
<style scoped>
@font-face {
   font-family: 'Noto Sans';
   src: url('../fonts/Noto_Sans/NotoSans-Light.ttf') format("truetype");
}
.divider{
   padding-left: 10px;
   padding-right: 10px;
}
a{
   color: white;
   text-decoration: none;
}
.title{
   font-size: 15px;
   margin-right: 15px;
   color: gray;
}

.copyright{
   color:white;
   width: 1180px!important;
   text-align: left;
   display: flex;
}
.socmed-container{
   background-color: black!important;
   justify-content: center;
   height: 55px;
}
.socmed{
   justify-content: right;
   text-align: right;
   width: 50%;
}
.socmed-content{
   margin-right: 10px;	
}
.socmed-image{
   width: auto;
   height: 18px;
}
.privacy-content{
   margin-right: 15px;
   color: white !important;
}
.privacy-container{
   font-size: 5px;
   width: 1180px;
   color: white !important;
   text-align: left;
}
a{
   color: #00AA7E;
}
</style>